import { Breadcrumb, Carousel } from '@cowsquare/design';
import { Link } from 'gatsby';
import gql from 'graphql-tag';
import * as R from 'ramda';
import React from 'react';
import { Query } from 'react-apollo';
import { Helmet } from 'react-helmet';
import defaultCover from '../../../../asset/defaultCover.jpg';
import { dateFormat } from '../../../../utils/dateFormat';
import { ArticleContent } from '../../../ArticleContent';
import { BreadcrumbWrapper } from '../../../BreadcrumbWrapper';
import { Section } from '../../../Section';
import PageNotFound from '../../error/404';

// TODO: 換成 e drug 的 new-drugs record query
const GET_E_DRUG_SALES_RECORD = gql`
  query getEDrugSalesRecord($id: uuid!) {
    record: hkdutest_e_drug_sales_by_pk(id: $id) {
      id
      author {
        name
        email
      }
      name
      e_drug_content {
        content
      }
      cover_file {
        link
      }
      created_at
    }
  }
`;

const NewDrugContent = ({ id, uri }) => (
  <Query query={GET_E_DRUG_SALES_RECORD} variables={{ id }}>
    {({ data, loading }) => {
      if (!loading && !R.prop('record', data)) {
        return <PageNotFound />;
      }

      const record = R.propOr({}, 'record', data);
      const coverUrl = R.pathOr(defaultCover, ['cover_file', 'link'], record);
      const title = R.propOr('', 'name', record);
      const content = R.pathOr('', ['e_drug_content', 'content'], record);
      const authorName = R.pathOr('', ['author', 'name'], record);
      const createdAt = R.propOr(null, 'created_at', record);
      const info = `${authorName} Published at ${createdAt ? dateFormat(createdAt) : ''}`;

      return (
        <Section>
          <Helmet>
            <title>{title} - HKDU E-Pharm</title>
          </Helmet>
          <Carousel>
            <Carousel.Slide backgroundImage={`url(${coverUrl})`} height={['150px', '300px']} />
          </Carousel>
          <BreadcrumbWrapper>
            <Breadcrumb>
              <Breadcrumb.Item linkProps={{ as: Link, to: R.replace(id, '', uri) }}>
                New Drugs
              </Breadcrumb.Item>
              <Breadcrumb.Item>{title}</Breadcrumb.Item>
            </Breadcrumb>
          </BreadcrumbWrapper>
          <ArticleContent title={title} info={info} content={content} />
        </Section>
      );
    }}
  </Query>
);

export default NewDrugContent;
